import React, {Component} from 'react';
import Radium from 'radium';
import color from 'color';

class MessageListSuggestions extends Component {

	constructor(props) {
		super(props);
	}

	triggerScrollToBottom() {
		this.setState({scrolled: true});
		this.props.scrollToBottom();
	}

	render() {
		let clientColor = this.props.client.get("tint");
		const suggestedResponseList = this.props.suggestedResponses.map((response, i) => {
			return (
				<button 
					key={i} 
					className="suggested-response" 
					style={[
						styles.suggestedResponses.suggestedResponse,
						{
							borderColor: clientColor,
							color: clientColor,
							':hover': {
								backgroundColor: clientColor,
								color: 'white',
								opacity: '0.75'
							},
							':active': {
								backgroundColor: clientColor,
								opacity: '1',
								color: 'white'
							},
							'::-webkit-scrollbar': {
								display: 'none'
							}
						},
						this.props.client.get("isMobile") && styles.suggestedResponses.suggestedResponse.mobile,
						response === this.props.suggestedResponses.first() && this.props.client.get("isMobile") && styles.suggestedResponses.suggestedResponse.mobileFirst,
						response === this.props.suggestedResponses.last() && this.props.client.get("isMobile") && styles.suggestedResponses.suggestedResponse.mobileLast
					]}
					title={`Send "${response.get("body")}"`}
					onClick={() => this.props.handlePostBack(response)}
				>
					{response.get("body")}
				</button>
			)
		});

		return (
			<div 
				className="suggested-responses" 
				style={[
					styles.suggestedResponses,
					this.props.client.get("isMobile") && styles.suggestedResponses.mobile,
					this.props.showElement && styles.suggestedResponses.show
				]}
			>
				<div 
					className="suggested-responses__scrollable" 
					style={[
						styles.suggestedResponses.scrollable,
						this.props.client.get("isMobile") && styles.suggestedResponses.scrollable.mobile
					]} 
				>
					{suggestedResponseList}
				</div>
				{this.props.client.get("isMobile") &&
					<div 
						className="suggested-responses__gradient m-right" 
						style={[
							styles.suggestedResponses.gradient
						]} 
					>
					</div>
				}
			</div>
		)
	}
}

const transformMessage = Radium.keyframes({
	'0%': { 
		transform: 'translateY(20px)',
		opacity: 0
	},
	'100%': { 
		transform: 'translateY(0px)' ,
		opacity: 1
	}
});

const styles = {
	suggestedResponses: {
	    position: 'relative',
    	overflow: 'hidden',

		show: {
			animationName: transformMessage,
			animationDuration: '0.2s'
		},

		mobile: {
			height: '42px',
    	    margin: '0 -10px'
		},

	    scrollable: {
	    	WebkitOverflowScrolling: 'touch',
    		marginTop: '6px',

	    	mobile: {
				overflowX: 'scroll',
			    whiteSpace: 'nowrap',
		    	position: 'absolute',
		    	paddingBottom: '20px',
		    	marginTop: '6px',
		    	left: 0,
		    	top: 0,
		    	right: 0
	    	}
	    },

	    gradient: {
			position: 'absolute',
			right: '0',
			top: '0',
			height: '100%',
			width: '30px',
			background: 'linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))',
			pointerEvents: 'none'
	    },

		suggestedResponse: {
			padding: '7px 12px',
			marginLeft: '3px',
			marginRight: '3px',
			backgroundColor: 'white',
			display: 'inline-block',
			borderRadius: '12px',
			fontSize: '18px',
			outline: '0',
			cursor: 'pointer',
			borderWidth: '1px',
			borderStyle: 'solid',
			minHeight: '35px',
			verticalAlign: 'top',
			marginBottom: '6px',
			textAlign: 'left',

	    	mobile: {
				height: '35px',
				padding: '0 12px'
	    	},

			mobileFirst: {
				marginLeft: '10px'
			},

			mobileLast: {
				marginRight: '30px'
			}
		}
	}
}

export default Radium(MessageListSuggestions);


// WEBPACK FOOTER //
// ./src/components/MessageList/MessageListSuggestions.js